"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3ConfigurationModule = void 0;
const axios_1 = __importDefault(require("axios"));
const context_1 = require("@derivation-tech/context");
const utils_1 = require("../../utils");
const configuration_base_module_1 = require("./configuration.base.module");
const suppotedChainId = new Set([context_1.CHAIN_ID.BASE, context_1.CHAIN_ID.BLAST, context_1.CHAIN_ID.MONADTESTNET]);
class S3ConfigurationModule extends configuration_base_module_1.ConfigurationModuleBase {
    constructor(context, basePath) {
        super(context);
        this.basePath = basePath ?? 'https://api.synfutures.com/s3/config/sdkConfig';
    }
    async getConfig() {
        if (!suppotedChainId.has(this.context.chainId)) {
            return null;
        }
        const url = this.basePath + '/' + this.context.chainId + '.json';
        const res = await axios_1.default.get(url);
        return (0, utils_1.loadConfig)(res.data);
    }
}
exports.S3ConfigurationModule = S3ConfigurationModule;
